import { Grid } from "@mui/material";
import { Box, styled } from "@mui/system";
import { Link } from "react-router-dom";
import Header from "../../components/custom/Header";
import SecondaryButton from "../../components/custom/SecondaryButton";
import DataGrid2 from "../../components/custom/Table2/DataGrid2";
import { getDashboardInfo } from "../../services/dashBoardServices";
import React, { useEffect } from "react";

import {
  downloadAcsm,
  exportBooks,
  getBooks,
  deleteBook,
} from "../../services/booksServices";
import { saveAs } from "file-saver-es";
import Dialog from "../../components/custom/Dialog";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const StyledContainer = styled(Grid)`
  width: 100%;
  height: 100%;
`;

const Container = styled(Box)`
  width: auto;
`;

const All = () => {
  const [showDialog, setShowDialog] = useState(false);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [idToDelete, setIdToDelete] = useState(null);
  const [deleteCompleted, setDeleteCompleted] = useState(false);
  const [, setTitleToDelete] = useState("");
  const [totalNumber, setTotalNumber] = useState("");
  const [remainingNumber, setRemainingNumber] = useState("");

  const [message, setMessage] = useState("");
  const { t } = useTranslation();
  const columns = [
    { key: "title", dataField: "title", caption: "Title" },
    { key: "isbn", dataField: "isbn", caption: "ISBN" },
    { key: "uuid", dataField: "uuid", caption: "Uuid" },
    { key: "batchId", dataField: "batchId", caption: "BatchId" },
    { key: "status", dataField: "status", caption: "Status" },
  ];

  const toolbarOptions = {
    bulk: {
      show: true,
      request: null,
    },
    export: {
      show: true,
      request: exportBooks,
    },
  };

  const fetchDashboardInfo = async () => {
    try {
      const res = await getDashboardInfo();
      setTotalNumber(res?.bookUploads);
      setRemainingNumber(res?.totalUploads);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchDashboardInfo();
  }, []);

  const handleDownloadAcsmFile = async (id) => {
    try {
      const res = await downloadAcsm(id);
      saveAs(new Blob([res.data]), "URLLink.acsm");
    } catch (error) {
      setShowDialog(true);
      setMessage(t("FileDownloadError"));
      if (error.response.status === 424 || error.response.status === 401) {
        setMessage(error.response.data);
      }
      console.error(error);
    }
  };

  const performDeleteBook = async (id) => {
    try {
      const res = await deleteBook(id);
      return res.data;
    } catch (error) {
      return error.response.data;
    }
  };

  const openDeleteDialogAndSetIdToDelete = (id, title) => {
    setTitleToDelete(title);
    setIdToDelete(id);
    setMessage("Do you want to delete book with title '" + title + "' ?");
    setShowDeleteDialog(true);
  };

  return (
    <StyledContainer sx={{ p: { xs: 2, md: 10 } }}>
      <Grid item>
        <Header
          name="Books"
          productShow={true}
          totalNumber={totalNumber}
          remainingNumber={remainingNumber}
          quantityFrom={"Total number of uploaded books"}
          quantityTo={"Total number of remaining book uploads"}
        />
      </Grid>
      <Container>
        <SecondaryButton component={Link} to="upload">
          + Add new book
        </SecondaryButton>
        <DataGrid2
          id={"booksAll"}
          filename="books"
          cols={columns}
          getAll={getBooks}
          // downloadAcsmFile={downloadAcsm}
          toolbarOptions={toolbarOptions}
          editUrl={"/books/"}
          //  deleteRow={console.log}
          handleDownloadAcsmFile={handleDownloadAcsmFile}
          handleDeleteBook={openDeleteDialogAndSetIdToDelete}
          message={message}
        />
      </Container>
      <Dialog
        showCancel={false}
        showButton={false}
        action={() => {
          setShowDialog(false);
        }}
        onClose={() => setShowDialog(false)}
        open={showDialog}
      >
        {message}
      </Dialog>
      <Dialog
        showCancel={!deleteCompleted}
        showButton={false}
        action={async () => {
          if (deleteCompleted) {
            setShowDeleteDialog(false);
            setTimeout(() => setDeleteCompleted(false), 500);
          } else {
            setMessage("Deleting book... please wait...");
            setDeleteCompleted(true);
            const message = await performDeleteBook(idToDelete);
            setMessage(message);
            //setDeleteCompleted(true);
          }
        }}
        onClose={() => setShowDeleteDialog(false)}
        open={showDeleteDialog}
        style={{ textAlign: "center" }}
      >
        {message}
      </Dialog>
    </StyledContainer>
  );
};

export default All;
